import request from "./request";

export const listCourseReview = () => {
	return request({
		url: `/api/api/h5/anno/listCourseReview`,
		method: "get"
	});
};

export const getCourseReviewListByPage = (params) => {
	return request({
		url: `/api/api/h5/anno/getCourseReviewList/${params.categoryId}`,
		method: "get",
		params: params
	});
};

export const getCourseReviewList = (categoryId) => {
	return request({
		url: `/api/api/h5/anno/getCourseReviewList/${categoryId}`,
		method: "get"
	});
};

export const getCategoryList = (type) => {
	return request({
		url: `/api/api/h5/anno/getCategoryList/${type}`,
		method: "get"
	});
};

export const getListContentByCategoryIdDetail = (categoryId, params) => {
	return request({
		url: `/api/api/h5/anno/listContentByCategoryId/detail/${categoryId}`,
		method: "get",
		params: params
	});
};

export const getListContentByTypeIdDetail = (id, params) => {
	return request({
		url: `/api/api/h5/anno/listContentByTypeId/detail/${id}`,
		method: "get",
		params: params
	});
};

export const getListCompanyCase = (params) => {
	return request({
		url: `/api/api/h5/anno/company/listCompanyCase`,
		method: "get",
		params: params
	});
};

export const getPageOfflineCourse = (params) => {
	return request({
		url: `/api/api/h5/anno/pageOfflineCourse`,
		method: "get",
		params: params
	});
};

export const getListProductSystemCategory = (params) => {
	return request({
		url: `/api/api/h5/anno/company/listProductSystemCategoryForPC`,
		method: "get",
		params: params
	});
};

export const apiLogin = (query) => {
	return request({
		url: "/api/api/pc/anno/login",
		method: "post",
		data: query,
	});
};

export const listProductSystemCategoryForPCToC = (params) => {
	return request({
		url: `/api/api/h5/anno/company/listProductSystemCategoryForPCToC`,
		method: "get",
		params: params
	});
};

export const getContentById = (id, params) => {
	return request({
		url: `/api/api/h5/home/getContentById/detail/${id}`,
		method: "get",
		params: params
	});
};

export const getListDateCourseSum = (params) => {
	return request({
		url: `/api/api/h5/anno/listDateCourseSum`,
		method: "get",
		params: params
	});
};


export const getBanner = (id) => {
	return request({
		url: `/api/api/h5/anno/getBanner/${id}`,
		method: "get"
	});
};

export const listContentByTypeId = (params) => {
	return request({
		url: `/api/api/h5/anno/listContentByTypeId/detail/1`,
		method: "get",
		params: params
	});
};

// 获取logo墙数据，2024年10月26日00:14:47
export const listLogo = () => {
	return request({
		url: `/api/api/h5/anno/company/listLogo`,
		method: "get"
	});
};

// 企培专区-解决方案链接跳转：根据分类Id获取一条数据的详情，2024年10月26日09:27:58
export const getContentByCategoryId = (categoryId) => {
	return request({
		url: `/api/api/h5/anno/getContentByCategoryId/detail/${categoryId}`,
		method: "get"
	});
};

// 不需要校验登录，2024年10月26日10:14:52
export const getContentByIdNotNeedLogin = (id) => {
	return request({
		url: `/api/api/h5/anno/getContentById/detail/${id}`,
		method: "get"
	});
};

// 水印相关配置，2024年11月21日09:51:01
export const getWaterOpenState = () => {
	return request({
		url: `/api/api/h5/anno/getWaterOpenState`,
		method: "GET",
	});
}

export const getWaterUrl = () => {
	return request({
		url: `/api/api/h5/anno/getWaterUrl`,
		method: "GET",
	});
}

// 获取微信群二维码，2024年12月25日17:25:32
export const getWxGroup = (id) => {
	return request({
		url: `/api/api/h5/anno/get-wx-group/${id}`,
		method: "get"
	});
};
